import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
// import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
// import buyertop from 'src/assets/premium-signup-buyertop.png'
import Logo from 'src/components/Header/Logo'
import { vendorPlanFeatures } from 'src/constants/constants'

import styles from './SignUp.module.css'

export const VendorTeaser: React.FC = () => {
  return (
    <div
      className="bg-navy md:w-[650px] w-full p-5 md:pl-[70px] md:pr-[50px] md:pt-[50px] h-auto bg-cover"
      style={{
        backgroundImage: 'url(' + '/banner-bg.png' + ')',
      }}
    >
      <Link href="/">
        <Logo className="w-[200px] h-[35px]" />
      </Link>

      <div className={cn(styles.signupDescription, 'mt-[75px] mb-[50px]')}>
        <p className="font-bold text-[1.9rem]">
          Sign up for a <span style={{ color: '#a19cf7' }}>vendor account</span> to create, manage, and upgrade your
          listings
        </p>
      </div>

      {vendorPlanFeatures.map((option, index) => (
        <div key={index} className="flex flex-row h-[20px] mt-[15px] items-center">
          <IonIcon
            name="checkmark-circle"
            style={{ color: '#a19cf7', marginRight: '12px', height: '20px', width: '20px' }}
          />
          <p className={cn(styles.signupList, 'flex-1 md:h-[20px]')}>{option}</p>
        </div>
      ))}
      {/* <div className="my-[40px]">
        <Image src={buyertop} alt="" />
      </div> */}
    </div>
  )
}
